import apiProxy from './api-proxy-inst';

class ErpApi {
  erpInstList(args) {
    return apiProxy.request('/cur_user_erpapp_inst/list', args).then(data => {
      return data;
    });
  }

  erpInstModify(args) {
    return apiProxy.request('/cur_user_erpapp_inst_info/modify', args).then(data => {
      return data;
    });
  }

  erpCountryList(args) {
    return apiProxy.request('/country/list', args).then(data => {
      return data;
    });
  }
}

export default new ErpApi();